export interface ValueAddedServiceActionTypes {
  type: ValueAddedServiceActions;
  payload?: any;
}

export enum ValueAddedServiceActions {
  GET_VALUE_ADDED_SERVICE_LIST = "GET_VALUE_ADDED_SERVICE_LIST",
  SET_VALUE_ADDED_SERVICE_LIST = "SET_VALUE_ADDED_SERVICE_LIST",
  EDIT_VALUE_ADDED_SERVICES = "EDIT_VALUE_ADDED_SERVICES",
}
